/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgradetobusinesstitle3Inputs */

const en_upgradetobusinesstitle3 = /** @type {(inputs: Upgradetobusinesstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete your business account`)
};

const de_upgradetobusinesstitle3 = /** @type {(inputs: Upgradetobusinesstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business-Konto vervollständigen`)
};

/**
* | output |
* | --- |
* | "Complete your business account" |
*
* @param {Upgradetobusinesstitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradetobusinesstitle3 = /** @type {((inputs?: Upgradetobusinesstitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradetobusinesstitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradetobusinesstitle3(inputs)
	return de_upgradetobusinesstitle3(inputs)
});
export { upgradetobusinesstitle3 as "upgradeToBusinessTitle" }